// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__TTcU {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

.categoriesContainer_PX5Nl,
.itemsContainer_NMrXo {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.categoriesScroll__5OHT,
.itemsScroll_F83LG {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
    width: 100%;
    position: relative;
}

.itemsScroll_F83LG {
    grid-template-columns: 1fr 1fr 1fr 1fr;
}

.categoriesScroll__5OHT::-webkit-scrollbar,
.itemsScroll_F83LG::-webkit-scrollbar {
    height: 6px;
}

.categoriesScroll__5OHT::-webkit-scrollbar-track,
.itemsScroll_F83LG::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.categoriesScroll__5OHT::-webkit-scrollbar-thumb,
.itemsScroll_F83LG::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

.categoryItem_WLYLI {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px;
    background: #f8f9fa;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.categoryItem_WLYLI:hover {
    background: #e9ecef;
}

.categoryIcon_Vg9I3 {
    font-size: 18px;
}

.categoryTitle_uT5kQ {
    font-size: 10px;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
}

.backButton_scDgQ {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.backButton_scDgQ:hover {
    background: #e9ecef;
}

.backIcon_fax2V {
    font-size: 12px;
}

.item_dlJOe {
    padding: 6px;
    background: #f8f9fa;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
}

.item_dlJOe:hover {
    background: #e9ecef;
}

.itemIcon_O7KNL {
    font-size: 28px;
}

.itemTitle_sTVVc {
    font-size: 9px;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/FileInput/selectInfoToProcces/FilterDocs.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".container {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n}\n\n.categoriesContainer,\n.itemsContainer {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n.categoriesScroll,\n.itemsScroll {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #888 #f1f1f1;\n    width: 100%;\n    position: relative;\n}\n\n.itemsScroll {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n}\n\n.categoriesScroll::-webkit-scrollbar,\n.itemsScroll::-webkit-scrollbar {\n    height: 6px;\n}\n\n.categoriesScroll::-webkit-scrollbar-track,\n.itemsScroll::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 3px;\n}\n\n.categoriesScroll::-webkit-scrollbar-thumb,\n.itemsScroll::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 3px;\n}\n\n.categoryItem {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 6px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.categoryItem:hover {\n    background: #e9ecef;\n}\n\n.categoryIcon {\n    font-size: 18px;\n}\n\n.categoryTitle {\n    font-size: 10px;\n    text-transform: capitalize;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 150px;\n}\n\n.backButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1rem;\n    background: #f8f9fa;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.backButton:hover {\n    background: #e9ecef;\n}\n\n.backIcon {\n    font-size: 12px;\n}\n\n.item {\n    padding: 6px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: inline-flex;\n    flex-direction: column;\n    gap: 10px;\n    align-items: center;\n}\n\n.item:hover {\n    background: #e9ecef;\n}\n\n.itemIcon {\n    font-size: 28px;\n}\n\n.itemTitle {\n    font-size: 9px;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__TTcU`,
	"categoriesContainer": `categoriesContainer_PX5Nl`,
	"itemsContainer": `itemsContainer_NMrXo`,
	"categoriesScroll": `categoriesScroll__5OHT`,
	"itemsScroll": `itemsScroll_F83LG`,
	"categoryItem": `categoryItem_WLYLI`,
	"categoryIcon": `categoryIcon_Vg9I3`,
	"categoryTitle": `categoryTitle_uT5kQ`,
	"backButton": `backButton_scDgQ`,
	"backIcon": `backIcon_fax2V`,
	"item": `item_dlJOe`,
	"itemIcon": `itemIcon_O7KNL`,
	"itemTitle": `itemTitle_sTVVc`
};
export default ___CSS_LOADER_EXPORT___;
